import { Button } from "@/components/ui/baseUi/button"
import { Text } from "@/components/ui/baseUi/text"
import { BoxSlotTypeOf } from "@/modules/boxSlot/boxSlotTypes"
import { SessionTypeOf } from "@/modules/sessions/programSessionTypes"
import type { TrainingItemEntityType } from "@/modules/training/entities/trainingContentEntity"
import SessionEmpty from "@images/empty/session_empty.svg"
import { word } from "@modules/core/utils/i18n"
import { SessionCard } from "@modules/dashboard/components/cards/sessionCard"
import { useMySpaceNavigate } from "@modules/navigation/hooks/useMySpaceNavigate"
import { Path } from "@modules/navigation/routes"
import { useTrainingSessionsToday } from "@modules/training/hooks/useTraining"
import { EmptyView } from "@modules/ui/components/emptyView"
import { useCallback } from "react"
import { Link } from "react-router"
import styled from "styled-components"

export function SessionsResume(props: React.ComponentProps<"div">) {
  const { trainingToday } = useTrainingSessionsToday()
  const mySpaceNavigate = useMySpaceNavigate()

  const returnContent = useCallback((content: TrainingItemEntityType, index: number) => {
    switch (content.type) {
      case SessionTypeOf:
      case BoxSlotTypeOf:
        return <SessionCard key={index} session={content.content} />
      default: {
        const exhaustiveCheck: never = content
        throw new Error(`No session content find ${JSON.stringify(exhaustiveCheck)}`)
      }
    }
  }, [])

  return (
    // TODO: change bg-neutral-100 to bg-surface-card
    <div className="rounded-4xl bg-neutral-100 px-5 py-7" {...props}>
      <div className="flex w-full items-center justify-between">
        <Text fontStyle="TL" className="mb-2">
          {word("home.screen.sessions.title")}
        </Text>
        {trainingToday.length > 1 && (
          <Button variant="underline" size="sm">
            <Link
              to={Path.MySpace.Training}
              onClick={(e) => {
                e.preventDefault()
                mySpaceNavigate(Path.MySpace.Training)
              }}
            >
              {word("global.button.seeAll")}
            </Link>
          </Button>
        )}
      </div>
      {trainingToday.length > 0 ? (
        trainingToday.slice(0, 2).map((session, index) => returnContent(session, index))
      ) : (
        <>
          <EmptyViewStyled
            image={{ src: SessionEmpty }}
            title={word("dashboard.planning.empty.title")}
            description={word("dashboard.planning.empty.description")}
            flexGrow={false}
            className="mt-2 p-2"
            textAlign="center"
            disposition="column-reverse"
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          />
          <Button variant="outline" className="w-full">
            <Link
              to={Path.MySpace.Explore}
              onClick={(e) => {
                e.preventDefault()
                mySpaceNavigate(Path.MySpace.Explore)
              }}
            >
              {word("programs.discover")}
            </Link>
          </Button>
        </>
      )}
      {trainingToday.length === 1 && (
        <div>
          <div className="my-4 flex flex-col items-center text-center">
            <Text fontStyle="TM" className="mb-2">
              {word("home.screen.sessions.empty.title")}
            </Text>
            <Text fontStyle="BM">{word("home.screen.sessions.empty.description")}</Text>
          </div>
          <Button
            variant="outline"
            className="w-full"
            nativeButton={false}
            render={
              <Link
                to={Path.MySpace.Explore}
                onClick={(e) => {
                  e.preventDefault()
                  mySpaceNavigate(Path.MySpace.Explore)
                }}
              >
                {word("programs.discover")}
              </Link>
            }
          />
        </div>
      )}
    </div>
  )
}

const EmptyViewStyled = styled(EmptyView)`
  & > div > div:nth-child(2) > span:nth-child(1) {
    font-size: 1.125rem;
  }
`
